module.exports = __webpack_public_path__ + "img/logo.8b8daed1.png";